mainApp.component('deviceAuthenticationConfiguration',{
    templateUrl: '/public/components/deviceAuthenticationConfiguration.html',
    bindings: {
        model: '=',
        isOverrideComponent: '=',
        changesListener: '&',
    },
    controller: deviceAuthenticationConfigurationController
});

function deviceAuthenticationConfigurationController($scope, $state) {
    const $ctrl = this;

    $ctrl.$onInit = function() {
        reload();
    };

    $ctrl.$doCheck = function() {
        if (!$ctrl.changesListener)
            return;

        const isChangedNow = !angular.equals($ctrl.model, $ctrl.original);

        //check if listener was already called and updates about having changes
        if ($ctrl.hasChanges === isChangedNow)
            return;

        $ctrl.hasChanges = isChangedNow;
        $ctrl.changesListener({isDirty: $ctrl.hasChanges, componentName: 'deviceAuthenticationConfiguration'});
    };

    function reload() {
        $ctrl.original = angular.copy($ctrl.model);
    }

    $scope.$on('modelReloadedEvent', function (event, data) {
        reload();
    });

    $ctrl.OSTypesTableConfig = {
        dataURL: function(){
            if (!$state.params || !$state.params.accountId) {
                return null;
            }
            return "/getOSTypes";
        },
        fields: [
            {
                label: 'Operating System',
                path: 'name',
                noSort: true
            },
        ],
        parseData: function (data) {
            return data;
        },
        actions: [],
        selectedItems: [],
        selectIdentifier: 'id',
        listType: '',
        noSearch: true
    };

    $ctrl.selectOSTypes = function (listName) {
        $ctrl.OSTypesTableConfig.listType = listName;
        $ctrl.OSTypesTableConfig.selectedItems = [];
        switch (listName) {
            case "BLOCKED":
                $ctrl.OSTypesTableConfig.items.map((item) => item.hide = false);
                $ctrl.model.blockedOSs.forEach(osType => {
                    $ctrl.OSTypesTableConfig.selectedItems.push(osType);
                });
                break;
            case "REQUIRES_CERT":
                // Linux and Android are not an option in this list
                $ctrl.OSTypesTableConfig.items.map((item) => item.hide = item.id === 'ANDROID');
                $ctrl.model.certificateRequiredOSs.forEach(osType => {
                    $ctrl.OSTypesTableConfig.selectedItems.push(osType);
                });
                break;
        }

        $scope.$root.openPopup('OSTypesDlg');
    };

    $ctrl.addOSTypes = function () {
        let updatedOSList = [];
        $ctrl.OSTypesTableConfig.selectedItems.forEach(function (OSType) {
            updatedOSList.push(OSType);
        });
        switch ($ctrl.OSTypesTableConfig.listType) {
            case "BLOCKED":
                $ctrl.model.blockedOSs = updatedOSList;
                break;
            case "REQUIRES_CERT":
                $ctrl.model.certificateRequiredOSs = updatedOSList;
                break;
        }
        $scope.$root.closePopup('OSTypesDlg');
    };

    $ctrl.clearLists = function () {
        if (!$ctrl.model.isOverrideAccountSettings) {
            $ctrl.model.blockedOSs = [];
            $ctrl.model.certificateRequiredOSs = [];
        }
    }

}
